import {Injectable} from '@angular/core';
import {OrganizationPageResponse} from '@npck/af-frontend-api';
import {RouterService} from '@npck/libs/commons';
import dayjs from 'dayjs';
import {initialTableEvent, TableEvent} from '../components/full-table/full-table.component';
import {Path} from '../path';

@Injectable({providedIn: 'root'})
export class OrganizationsFilterHolderService {
    private tableHolder = this.initialState();

    constructor(
        private routerService: RouterService,
    ) {
        this.routerService.navigationEnd()
            .subscribe(event => {
                if (!event.url.includes(Path.ADMIN_PANEL)) {
                    this.clear();
                }
            });
    }

    storeTableState(tableEvent: TableEvent): OrganizationsTableInfo {
        this.tableHolder = {...this.tableHolder, tableEvent};
        return this.tableHolder;
    }

    storeResponse(response: OrganizationPageResponse): void {
        this.tableHolder = {...this.tableHolder, response, cachedTime: dayjs()};
    }

    getState(): OrganizationsTableInfo {
        return this.tableHolder;
    }

    clear(): void {
        this.tableHolder = this.initialState();
    }

    private initialState(): OrganizationsTableInfo {
        return <OrganizationsTableInfo>{
            tableEvent: {...initialTableEvent},
        };
    }
}

export interface OrganizationsTableInfo {
    tableEvent: TableEvent;
    response?: OrganizationPageResponse;
    cachedTime: dayjs.Dayjs;
}
